import {Component, Input} from '@angular/core';
import {faQuestionCircle} from '@fortawesome/free-regular-svg-icons';
import {Popover} from 'primeng/popover';

@Component({
    selector: 'wm-helpdropdown',
    styleUrls: ['./helpdropdown.component.less'],
    template: `
        <div class="wm-helpdropdown-container" (click)="op.toggle($event);">
            <div class="wm-helpdropdown-label" data-testing-id="helpdropdown-label">
                <fa-icon size="lg" [icon]="QuestionCircle"></fa-icon>
            </div>
            <p-popover appendTo="body" [styleClass]="'navbar-dropdown'" #op>
                <a class="wm-helpdropdown-item" data-testing-id="navbar-help-menu-docs" (click)="navigateToDocs(op)"> Docs</a>
                <a class="wm-helpdropdown-item" data-testing-id="navbar-help-menu-docs" (click)="navigateToFaq(op)"> FAQ</a>
                <a class="wm-helpdropdown-item" data-testing-id="navbar-help-menu-support" (click)="navigateToSupport(op)"> Support</a>
                <a class="wm-helpdropdown-item" data-testing-id="navbar-help-menu-docs" (click)="navigateToStatuspage(op)"> Status</a>
                @if(window['Marker']) {
                  <a class="wm-helpdropdown-item" data-testing-id="navbar-help-menu-feedback" (click)="launchMarker()"> Feedback</a>
                }
            </p-popover>
        </div>
    `
})
export class HelpDropdownComponent {
    @Input() demoInstance: boolean = false;
    QuestionCircle = faQuestionCircle;

    navigateToDocs(op: Popover) {
        op.hide();
        if (this.demoInstance) {
            window.open('https://docs.webmate.io/first-steps/trial-period');
        } else {
            window.open('https://docs.webmate.io');
        }
    }

    navigateToFaq(op: Popover) {
        op.hide();
        window.open('https://docs.webmate.io/support/help/faq/');
    }

    navigateToSupport(op: Popover) {
        op.hide();
        window.open('https://docs.webmate.io/support/');
    }

    navigateToStatuspage(op: Popover) {
        op.hide();
        window.open('https://status.webmate.io/');
    }

    launchMarker() {
        // @ts-ignore
        window.Marker.capture('fullscreen');
    }

    protected readonly window = window;
}
